import { render } from "./LocalPokemon.vue?vue&type=template&id=7da85a7c&scoped=true"
import script from "./LocalPokemon.vue?vue&type=script&lang=js"
export * from "./LocalPokemon.vue?vue&type=script&lang=js"

import "./LocalPokemon.vue?vue&type=style&index=0&id=7da85a7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7da85a7c"

export default script